module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-15.5976e360.mp3";